import React, { useEffect, useCallback, useState } from "react";
import { holidaysMngtThunk } from "../../../store/actions/holidaymanagement/holiday.thunk";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { PageBody } from "../../../components/loader";
import { useLoadingMessage } from "../../../components/useLoadingMessage";
import ReactHTMLTableToExcel from "react-html-table-to-excel";

export const ReportLeave = () => {
  const { leaveRecords } = useSelector((state) => state.holidaysMngt);
  const dispatch = useDispatch();
  const [searchLeavs, setSearchLeavs] = useState("");
  const { isLoading, message, updateLoader } = useLoadingMessage();

  console.log("leaves", leaveRecords);

  const getAllLeaves = useCallback(async () => {
    await dispatch(holidaysMngtThunk.getAllHOlidays());
    await dispatch(holidaysMngtThunk.getLeaveRecord());
    updateLoader(false);
  }, [dispatch]);

  useEffect(() => {
    getAllLeaves();
  }, []);

  const AllLeaveRecords = leaveRecords.filter((record) => {
    return (
      record &&
      record.employee_name.toLowerCase().indexOf(searchLeavs.toLowerCase()) !==
        -1
    );
  });
  return (
    <React.Fragment>
      <PageBody isLoading={isLoading} message={message}>
        <div className="content">
          <div className="container-fluid">
            <div className="row">
              <div className="col-12">
                <div className="page-title-box-two">
                  <h4 className="page-title"></h4>
                  <h1 className="welcome_text">REPORT MANAGEMENT</h1>
                  <div className="clearfix"></div>
                </div>
              </div>
            </div>

            <div className="row">
              <div className="col-md-12">
                <div className=" table-responsive">
                  <div className="table-title">
                    <div className="row">
                      <div className="col-sm-6">
                        <h2>
                          <b> LEAVE SUMMARY </b>{" "}
                        </h2>
                      </div>
                      <div className="col-sm-6">
                        <Link to="/dashboard/report" className="btn  p-3">
                          <span class="fa fa-arrow-left"></span>&nbsp;Back&nbsp;
                        </Link>
                      </div>
                    </div>
                  </div>

                  <div className="row">
                    <div className="col-sm-12 col-md-12 col-xs-12">
                      <div className="">
                        <div className="mb-3 clearfix">
                          <div
                            class="btn-group float-left"
                            role="group"
                            aria-label="Basic example"
                          >
                            <button
                              type="button"
                              class="btn btn-secondary btn-group-sm"
                              onClick={() => window.print()}
                            >
                              Print
                            </button>
                            <ReactHTMLTableToExcel
                              id="test-table-xls-button"
                              className="btn btn-secondary btn-group-sm"
                              table="report-leave"
                              filename="LEAVE SUMMARY"
                              sheet="tablexls"
                              buttonText="Export to excel"
                            />
                          </div>

                          <form class="form-inline my-2 my-lg-0 float-right">
                            <input
                              class="form-control mr-sm-2"
                              type="search"
                              placeholder="Search"
                              aria-label="Search"
                              name="search"
                              value={searchLeavs}
                              onChange={(e) => setSearchLeavs(e.target.value)}
                            />
                          </form>
                        </div>
                      </div>
                      <div className="" id="printTable">
                        <table
                          className="table table-striped table-hover learn-table"
                          id="report-leave"
                        >
                          {AllLeaveRecords < 1 ? (
                            <div className="text-center m-auto">
                              <h1 className="text-dark">No record found</h1>
                            </div>
                          ) : (
                            <thead>
                              <tr>
                                <th className="th-sm">
                                  <b> No </b>
                                </th>
                                <th className="th-sm">
                                  <b> EMPLOYEE </b>
                                </th>
                                <th className="th-sm">
                                  <b> ANNUAL LEAVE REQUESTS </b>
                                </th>
                                <th className="th-sm">
                                  <b> CASUAL LEAVE REQUESTS </b>
                                </th>
                                <th className="th-sm">
                                  <b> MATERNITY LEAVE REQUEST </b>
                                </th>
                                <th className="th-sm">
                                  <b> PATERNITY LEAVE REQUEST </b>
                                </th>
                                <th className="th-sm">
                                  <b> TOTAL LEAVE TAKEN </b>
                                </th>
                                <th className="th-sm">
                                  <b> APPROVED LEAVE REQUEST </b>
                                </th>
                                <th className="th-sm">
                                  <b> REJECTED LEAVE REQUEST </b>
                                </th>
                              </tr>
                            </thead>
                          )}
                          <tbody>
                            {AllLeaveRecords.map((record, i) => (
                              <tr>
                                <td>{i + 1}</td>
                                <td>{record.employee_name}</td>
                                <td>{record.annual_leave_request}</td>
                                <td>{record.casual_leave_request}</td>
                                <td>{record.maternity_leave_request}</td>
                                <td>{record.paternity_leave_request}</td>
                                <td>{record.total_leave_request}</td>
                                <td>{record.approved_leave_request}</td>
                                <td>{record.rejected_leave_request}</td>
                              </tr>
                            ))}
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </PageBody>
    </React.Fragment>
  );
};



// WEBPACK FOOTER //
// ./src/container/dashboard/reportmanagement/leave_list.js